import type { SVGProps } from "react";
export interface BatteryOffIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BatteryOffIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BatteryOffIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 14v-4a1.125 1.125 0 0 1 2.25 0v4a1.125 1.125 0 0 1-2.25 0m-3-.66V9c0-1.035-.84-1.875-1.875-1.875h-4.34a1.125 1.125 0 1 1 0-2.25H16A4.125 4.125 0 0 1 20.125 9v4.34a1.126 1.126 0 0 1-2.25 0M2.205 2.205a1.125 1.125 0 0 1 1.504-.078l.087.078 18 18 .076.085a1.125 1.125 0 0 1-1.582 1.583l-.085-.078-2.889-2.888c-.414.14-.857.218-1.316.218H5A4.125 4.125 0 0 1 .875 15V9a4.12 4.12 0 0 1 2.676-3.858L2.205 3.795l-.078-.084a1.125 1.125 0 0 1 .078-1.506M3.125 15c0 1.036.84 1.875 1.875 1.875h10.285l-9.75-9.75H5c-1.036 0-1.875.84-1.875 1.875z"
      />
    </svg>
  );
}
